import { OTPType } from "@app/domains/authentication/models";

export const OTP_TYPE_INPUT_ALIAS: Record<OTPType, string> = {
  EMAIL: "email",
  PHONE: "telefone",
  WHATSAPP: "telefone",
};
